import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import { JobAddNewContactFormComponentPropTypes } from 'src/components/JobExternalStakeholdersPopup/propTypes';
import SelectBox from 'src/components/SelectBox';
import TextField from 'src/components/TextField';
import Styles from 'src/components/JobExternalStakeholdersPopup/JobExternalStakeholdersPopup.styles';
import i18n from 'src/utils/i18n/i18n';

const JobAddNewContactForm = ({
  isLoading,
  disabled,
  setSelectedAffiliation,
  affiliationOptionsList,
  setInputFirstName,
  setInputLastName,
  setInputEmail,
  values,
  errors,
  setFieldValue,
  setNewContactFormError,
  isValid,
}) => {

  const { t } = useTranslation();

  useEffect(() => {
    if (!isValid) {
      setNewContactFormError(true);
    } else {
      setNewContactFormError(false);
    }
  }, [isValid]);

  const setValue = (fieldName, value) => {
    setFieldValue(fieldName, value);
    switch (fieldName) {
      case 'newContactSelectedAffiliation':
        setSelectedAffiliation(value);
        break;
      case 'newContactFirstName':
        setInputFirstName(value);
        break;
      case 'newContactLastName':
        setInputLastName(value);
        break;
      case 'newContactEmail':
        setInputEmail(value);
        break;
      default:
        break;
    }
  };

  return (
    <>

      <Styles.RowWrapperStacked>
        <Styles.RowLabel>{t('AFFILIATION')}</Styles.RowLabel>
        <SelectBox
          disabled={isLoading || disabled}
          error={errors.newContactSelectedAffiliation}
          id="newContactSelectedAffiliation"
          onChange={v => setValue('newContactSelectedAffiliation', v)}
          options={affiliationOptionsList}
          value={values.newContactSelectedAffiliation}
        />
      </Styles.RowWrapperStacked>
      <Styles.RowWrapperStacked>
        <Styles.RowLabel>{t('FORM_FIRST_NAME')}</Styles.RowLabel>
        <TextField
          disabled={isLoading || disabled}
          error={errors.newContactFirstName}
          id="newContactFirstName"
          onChange={e => setValue('newContactFirstName', e.target.value)}
          value={values.newContactFirstName}
        />
      </Styles.RowWrapperStacked>
      <Styles.RowWrapperStacked>
        <Styles.RowLabel>{t('FORM_LAST_NAME')}</Styles.RowLabel>
        <TextField
          disabled={isLoading || disabled}
          error={errors.newContactLastName}
          id="newContactLastName"
          onChange={e => setValue('newContactLastName', e.target.value)}
          value={values.newContactLastName}
        />
      </Styles.RowWrapperStacked>
      <Styles.RowWrapperStacked>
        <Styles.RowLabel>{t('FORM_WORK_EMAIL')}</Styles.RowLabel>
        <TextField
          disabled={isLoading || disabled}
          error={errors.newContactEmail}
          id="newContactEmail"
          onChange={e => setValue('newContactEmail', e.target.value)}
          value={values.newContactEmail}
        />
      </Styles.RowWrapperStacked>
    </>
  );
};

const JobAddNewContactFormComponent = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    newContactSelectedAffiliation: props.selectedAffiliation,
    newContactFirstName: props.inputFirstName,
    newContactLastName: props.inputLastName,
    newContactEmail: props.inputEmail,
  }),
  validationSchema: Yup.object().shape({
    newContactSelectedAffiliation: Yup.object().nullable().required(i18n.t('REQUIRED')),
    newContactFirstName: Yup.string().required(i18n.t('REQUIRED')),
    newContactLastName: Yup.string().required(i18n.t('REQUIRED')),
    newContactEmail: Yup.string().email(i18n.t('INVALID_EMAIL')).required(i18n.t('REQUIRED')),
  }),
  isInitialValid: false,
})(JobAddNewContactForm);

JobAddNewContactFormComponent.propTypes = JobAddNewContactFormComponentPropTypes;

export default JobAddNewContactFormComponent;
